/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditLock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 4a3 3 0 0 1 3 3v3H9V7a3 3 0 0 1 3-3zM7 7v3H4v12h9v-2H6v-8h12v1h2v-3h-3V7A5 5 0 0 0 7 7zm4 7v4h2v-4h-2zm4 6v3h3l5-5-3-3-5 5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEditLock as EditLock };
